module.exports = __webpack_public_path__ + "img/sv.e78b6497.svg";